<template>
  <div>
    <!-- <div class="lyon-display-medium-24">Schedule & Notes</div> -->
    <div v-if="canEditCms" class="d-flex justify-content-end">
      <a :href="fetchLegacyUrl(`/summer_schools/${$route.params.id}/schedules/new`)">
        <button class="btn btn-primary btn-sm">Add New schedule item</button>
      </a>
    </div>

    <line-loader v-if="loading" :size=2 />
    <div v-else-if="summerSchoolSchedules.length === 0">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-else v-for="(summer_school, index) in summerSchoolSchedules" :key="index">
      <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-3' : 'bg-shade-1 mb-3'">
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="regular-16 text-muted mb-2">
            <span>{{moment(summer_school.from, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
            <span> - </span>
            <span>{{moment(summer_school.to, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
          </div>
          <div class="bold-21">{{summer_school.name}}</div>
          </div>
        </div>
        <schedule-and-notes
          :data-id="$route.params.id"
          :grouped-schedules="summer_school.grouped_schedules"
          :main-index="index"
          edit-base-url="summer_schools"
          view-route-name="summer-graduate-schools-schedules"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import { mapGetters } from 'vuex'
import ScheduleAndNotes from '@/components/CommonPages/ScheduleAndNotes'
import LineLoader from '@/components/Loaders/LineLoader.vue'

export default {
  name: 'SummerGraduateSchoolScheduleAndNotesTabSection',
  components: { ScheduleAndNotes, LineLoader },
  mixins: [mixin],
  data () {
    return {
      summerSchoolSchedules: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters(['canEditCms'])
  },
  mounted() {
    this.loadSummerSchoolScheduleAndNotes()
  },
  methods: {
    loadSummerSchoolScheduleAndNotes() {
      this.loading = true
      this.$http.get(process.env.VUE_APP_API_URL + `/summer_schools/${this.$route.params.id}/summer_school_schedules_notes`)
      .then((res) => {
        this.summerSchoolSchedules = res.data.summer_school_schedules
        this.loading = false
      })
    }
  }
}
</script>
